import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Bonuses() {
  const bonuses = [{
    title: '20 Postres Proteicos en Airfryer',
    desc: 'Opciones dulces saludables para calmar antojos.'
  }, {
    title: '20 Aderezos Saludables',
    desc: 'Dale sabor a tus comidas sin sumar calorías vacías.'
  }, {
    title: 'Rutina de Ejercicio de 30 Días',
    desc: 'Movimiento simple para potenciar tus resultados.'
  }, {
    title: '20 Recetas Veganas',
    desc: 'Opciones 100% plant-based riquísimas.'
  }, {
    title: '50 Recetas Keto',
    desc: 'Bajas en carbohidratos, altas en sabor.'
  }, {
    title: '50 Recetas Sin TACC',
    desc: 'Opciones libres de gluten para toda la familia.'
  }];
  return <section className="py-24 bg-brand-600 text-white relative overflow-hidden" data-id="element-15">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-16"></div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="text-center mb-16" data-id="element-19">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white font-bold text-sm mb-6" data-id="element-20">
              <Gift className="w-4 h-4" data-id="element-21" />6 REGALOS EXCLUSIVOS
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-22">
              Llevate todo esto de regalo
            </h2>
            <p className="text-xl text-brand-100 max-w-2xl mx-auto" data-id="element-23">
              Para que comas delicioso y te puedas dar gustitos sin necesidad de
              privarte de cosas ricas.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-24">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-25">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl hover:bg-white/20 transition-colors" data-id="element-26">
                <div className="flex items-start gap-4" data-id="element-27">
                  <div className="bg-white text-brand-600 p-3 rounded-xl shrink-0 shadow-sm" data-id="element-28">
                    <Gift className="w-6 h-6" data-id="element-29" />
                  </div>
                  <div data-id="element-30">
                    <div className="text-brand-200 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-31">
                      Bonus #{i + 1}
                    </div>
                    <h3 className="font-bold text-lg mb-2 leading-tight" data-id="element-32">
                      {bonus.title}
                    </h3>
                    <p className="text-brand-100 text-sm" data-id="element-33">{bonus.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} data-id="element-34">
          <div className="text-center mt-14" data-id="element-35">
            <CtaButton label="Quiero el método + los 6 bonus" variant="light" data-id="element-36" />
          </div>
        </FadeIn>
      </div>
    </section>;
}